const salesAnalyticsDonutChart = {
    series: [0, 0, 0],
    chartOptions: {
        chart: {
            type: 'donut',
            height: 240,
        },
        labels: ['N.A', 'N.A', 'N.A'],
        colors: ['#556ee6', '#34c38f', '#f46a6a'],
        legend: {
            show: false,
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '70%',
                }
            }
        }
    }
};

const ChatData = [
    {
        noticeId: 1,
        name: 'Steven Franklin',
        message: 'Hello! Meeting @ 3 PM',
        time: '10:00',
    },
    {
        noticeId: 2,
        align: 'right',
        name: 'Henry Wells',
        message: 'Hi! Lets Meet everybody at Cafeteria.',
        time: '10:02'
    },
    {
        noticeId: 3,
        name: 'Steven Franklin',
        message: 'Project submission needs to be done by today.',
        time: '10:06'
    },
    {
        noticeId: 4,
        name: 'Steven Franklin',
        message: 'Tomorrow Holiday',
        time: '10:06'
    },
    {
        noticeId: 5,
        align: 'right',
        name: 'Henry Wells',
        message: "Hey Our Company got the biggest offer.",
        time: '10:02'
    },
]

export { salesAnalyticsDonutChart, ChatData };
